import { useTranslation } from "react-i18next";
import { Checkbox } from "src/components/Default/LekUI/Checkbox";

import { FormControlLabel, RadioGroup } from "../../../Default/LekUI/Checkbox";
import Filter from "../DefaultFilters";

export default function BasicExamTypeFilter(props) {
	const { t } = useTranslation();

	const setSelectedType = (value) => {
		const typeOfExam = value === props.selectedData.typeOfExam ? null : value;
		props.setSelectedData({ typeOfExam });
	};

	const renderFilters = () => {
		return (
			<RadioGroup
				onChange={(e) => setSelectedType(e.target.value)}
				value={props.selectedData.typeOfExam}
			>
				<FormControlLabel
					value="cem"
					label={props.filters[0].label}
					checked={props.selectedData.typeOfExam === "cem"}
					Control={<Checkbox />}
					onChange={(e) => setSelectedType(e.target.value)}
				/>
				<FormControlLabel
					value="all"
					label={props.filters[1].label}
					checked={props.selectedData.typeOfExam === "all"}
					Control={<Checkbox />}
					onChange={(e) => setSelectedType(e.target.value)}
				/>
			</RadioGroup>
		);
	};

	return (
		<Filter
			{...props}
			title={t("filters.exams.typeOfExam.title")}
			renderFilterDetails={renderFilters}
		/>
	);
}
